import React from 'react';
import { useSelector } from 'react-redux';
import { IDashMetrics } from '../../pages/dashboard/[[...index]]';

import styles from './common.module.css';
import SkeletonLoader from './skeleton-loader';
import IntentBarChartCard from './intent-bar-chart.component';
import ConversationMetricsCard from './conversation-metrics.component';
import ConversationMetrics from './conversation-metric.component';
import DetailedConvesrationsMetrics from './detailed-conversations.component';
import InvolvementPitchQualityMetrics from './involvement-pitch-quality-metric.component';
import { RootState } from '../../store/reducers';

interface IMetricsComponent {
  metrics: IDashMetrics | any;
  intentMetrics: {
    total_count: string;
    high_intent_percentage: string;
    list: {
      name: string;
      value: number;
      segments: {
        intent: string;
        value: number;
      }[]
    }[]
  };
  metricsLoading: boolean;
  isFilterApplied: boolean;
  handleFilterApply: (segmentName: string, barName: string) => void;
}

const MetricsComponent: React.FC<IMetricsComponent> = ({
  metrics = {},
  intentMetrics,
  metricsLoading,
  isFilterApplied,
  handleFilterApply
}) => {
  const { user } = useSelector((state: RootState) => state.common);
  const {
    total_conversation_count: conversationCount,
    conversation_count_growth: growthPercentage,
    total_duration: totalDuration,
    detailed_conversations: detailedConversationCount, 
    salesperson_involvement: salespersonInvolvement,
    customer_involvement: customerInvolvement,
    pitch_audit_score_latest: auditScore,
    avg_audit_score_conv_count: auditScoreCount,
    customer_involvement,
    total_conversation_count,
    total_duration,
    current_week_conversation_count,
    conversation_count_growth,
    salesperson_involvement,
    pitch_audit_score_latest,
    detailed_conversations,
    high_intent_contacts,
    avg_audit_score_conv_count
  } = metrics;

  return (
    <div>
      {metricsLoading ? (
        <div className={styles['metrics-container']}>
          {Array(3)
            .fill(true)
            .map((_, i) => (
              <SkeletonLoader key={i} />
            ))}
        </div>
      ) : (
        <div className={styles['metrics-container']}>
          {(user?.email.startsWith("zipteams@") || (user?.organisation.feature_flags.show_new_metrics || false)) ? (
            <>
              <IntentBarChartCard 
                intentMetrics={intentMetrics}
                handleFilterApply={handleFilterApply}
              />
              <ConversationMetricsCard 
                conversationCount={conversationCount}
                growthPercentage={growthPercentage}
                totalDuration={totalDuration}
                detailedConversationCount={detailedConversationCount}
                salespersonInvolvement={salespersonInvolvement}
                customerInvolvement={customerInvolvement}
                auditScore={auditScore}
                auditScoreCount={auditScoreCount}
                isFilterApplied={isFilterApplied}
              />
            </>
          ) : (
            <>
              <ConversationMetrics
                value={total_conversation_count}
                percentage={conversation_count_growth}
                currentWeekCalls={current_week_conversation_count}
                totalCallDuration={total_duration}
                totalConversationCount={total_conversation_count}
                isFilterApplied={isFilterApplied}
              />
              <DetailedConvesrationsMetrics
                detailed_conversations={detailed_conversations}
                high_intent_contacts={high_intent_contacts}
              />
              <InvolvementPitchQualityMetrics
                customer_involvement={customer_involvement}
                salesperson_involvement={salesperson_involvement}
                pitchAuditScore={pitch_audit_score_latest}
                pitchAuditScoreConvCount={avg_audit_score_conv_count}
              />
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default MetricsComponent;
